import { useTranslation } from 'react-i18next';
import { Flex, PageContainer } from '@/components';
import { useQuery, useMutation } from '@tanstack/react-query';
import RelativesInfoForm from './RelativesInfoForm';
import { SurveyHttp } from '@/services';

const RELATIONS_LIST = [
  'پدر',
  'مادر',
  'برادر',
  'خواهر',
  'همسر'
]

export function RelativesInfoPage() {

  const [t] = useTranslation(['common', 'survey']);

  const { data: relativesinfo } = useQuery({
    queryKey: ['/survey/relatives-info'],
    queryFn: async () => (await SurveyHttp.fetchRelativesInfo()),
  });

  const { data: studyLevels } = useQuery({
    queryKey: ['/rest/study-levels'],
    queryFn: async () => (await SurveyHttp.fetchStudylevels()),
  });

  const { mutateAsync: submitRelativesInfo } = useMutation({
    mutationKey: ['/survey/update/relatives-info'],
    mutationFn: async (data: RelativesInfoEntity[]) => await SurveyHttp.submitRelativesInfo(data),
  });

  return (
    <PageContainer title={t('common:labels.relatives-info')}>
      <Flex justify='center' align='center'>
        {(relativesinfo && studyLevels) &&
          <RelativesInfoForm
            relativesinfo={relativesinfo}
            studyLevels={studyLevels}
            submitRelativesInfo={submitRelativesInfo}
            relationsList={RELATIONS_LIST} />
        }
      </Flex>
    </PageContainer>
  );
}

export default RelativesInfoPage;
